import { ContactInput } from "../dtos/contact/input";
import Server from "./index";

export default class ContactServer extends Server {
  constructor() {
    super("/contact.php");
  }

  public post(data: ContactInput): Promise<any> {
    return super.post(data);
  }
}
